import React from "react";
import { alpha, Box, makeStyles, Typography, useTheme } from "@material-ui/core";

import type { CoretexTheme } from "../theme";

const useStyles = makeStyles((theme: CoretexTheme) => ({
  root: {
    display: "flex",
    alignItems: "center",
  },
  count: {
    fontWeight: theme.typography.fontWeightBold as number,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(0.5, 1),
    marginLeft: theme.spacing(2),
    minWidth: 16,
    minHeight: 20,
    fontSize: "12px",
  },
}));

interface BadgeProps {
  count: number;
  badgeColour?: React.CSSProperties["color"];
  children?: React.ReactNode;
}

const Badge = ({ count, badgeColour, children }: BadgeProps): JSX.Element => {
  const classes = useStyles();
  const theme = useTheme<CoretexTheme>();

  return (
    <Box className={classes.root}>
      {children}
      <Typography
        className={classes.count}
        style={{
          backgroundColor: alpha(badgeColour ?? theme.palette.mono.primaryDark ?? "", 0.1),
          color: badgeColour ?? theme.palette.mono.primaryDark,
        }}
      >
        {count}
      </Typography>
    </Box>
  );
};

export default Badge;
